import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=8ddac6da&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=8ddac6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddac6da",
  null
  
)

export default component.exports